import { MaintenanceAdminViewModel } from "@app/maintenance/maintenanceAdminViewModel";
import { MaintenanceRegisteredEntity } from "@app/maintenance/maintenanceRegisteredEntity";
import ServiceBase from "@app/shared/serviceBase";

/** Handles communication across the wire when interacting with maintenance */
export default class MaintenanceService extends ServiceBase {
  /**
   * Gets all of the users and roles for the application.
   */
  public async getMaintenanceAdminViewModel(): Promise<MaintenanceAdminViewModel> {
    return await this.makePost<MaintenanceAdminViewModel>(`maintenance/maintenance-admin-view-model`);
  }

  /**
   * Gets the countdown for the upcoming maintenance alert.
   * @param registeredEntities The registered entities we want to obtain maintenance times for.
   */
  public async getMaintenanceStatus(registeredEntities: string[]): Promise<MaintenanceRegisteredEntity[]> {
    return await this.makePost<MaintenanceRegisteredEntity[]>(`maintenance/maintenance-status`, registeredEntities);
  }

  /**
   * Gets maintenance users by a selected client.
   * @param clientId The client we want to find users for.
   */
  public async getMaintenanceUsersByClient(clientId: string): Promise<MaintenanceRegisteredEntity[]> {
    return await this.makePost<MaintenanceRegisteredEntity[]>(`maintenance/maintenance-users-by-client`, clientId);
  }

  /**
   * Gets users by an input name.
   * @param registeredEntities The registered entities we want to obtain maintenance times for.
   */
  public async getMaintenanceUsersByName(name: string): Promise<MaintenanceRegisteredEntity[]> {
    return await this.makePost<MaintenanceRegisteredEntity[]>(`maintenance/maintenance-users-by-name`, name);
  }

  /**
   * Updates the registered entities' maintenance page and alert statuses.
   * @param registeredEntities The registered entities to update.
   */
  public async updateMaintenanceRegisteredEntities(registeredEntities: MaintenanceRegisteredEntity[]): Promise<string> {
    return await this.makePost<string>(`maintenance/update-registered-entities`, registeredEntities);
  }
}
